import React from 'react'
import ContentLeft from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/Partials/ContentLeft'
import ContentRight from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/Partials/ContentRight'
import {
  FlexWrap,
  LeftSection,
  RightSection,
} from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/Style/style'

const PreviewContent = ({
  previewRoleData,
  jobSection = false,
  isRanking = false,
}) => {

  return (
    <FlexWrap gap="40px" padding="40px 30px">
      <LeftSection column>
        <ContentLeft
          isRanking={isRanking}
          jobSection={jobSection}
          previewRoleData={previewRoleData}
          tittle={previewRoleData?.tittle}
          jobTypeLevel={previewRoleData?.jobTypeLevels}
          jobType={previewRoleData?.jobType}
          yearOfExperience={
            previewRoleData?.yearOfExperience?.length > 0
              ? previewRoleData?.yearOfExperience
              : [0, 1]
          }
          minCompensation={previewRoleData?.minCompensation}
          maxCompensation={previewRoleData?.maxCompensation}
          description={previewRoleData?.description}
          interviewWorkFlow={previewRoleData?.interviewWorkFlow}
          internshipStartDate={previewRoleData?.internshipStartDate}
          internshipEndDate={previewRoleData?.internshipEndDate}
          ctcPeriod={
            previewRoleData?.CTCPeriod == 'ANNUALLY'
              ? 'Per annum'
              : previewRoleData?.CTCPeriod == 'MONTHLY'
              ? 'Per month'
              : previewRoleData?.CTCPeriod == 'WEEKLY'
              ? 'Per week'
              : previewRoleData?.CTCPeriod == 'DAILY'
              ? 'Per day'
              : previewRoleData?.CTCPeriod == 'HOURLY'
              ? 'Per hour'
              : ''
          }
          employmentType={
            previewRoleData?.employmentType == 'ONROLL' ? 'OnRoll' : 'Contract'
          }
          jobDependency={previewRoleData?.jobDependency}
          candidatesCount={previewRoleData?.minVacancies && previewRoleData?.maxVacancies 
            ? `${previewRoleData?.minVacancies} - ${previewRoleData?.maxVacancies}` 
            : previewRoleData?.maxVacancies || previewRoleData?.minVacancies || 'Not specified'}
          publishTo={previewRoleData?.publishTo}
        />
      </LeftSection>
      <RightSection column>
        <ContentRight
          jobSection={jobSection}
          previewRoleData={previewRoleData}
          endDate={previewRoleData?.endDate}
          cities={previewRoleData?.cities}
          isAnyWhere={previewRoleData?.isAnyWhere}
          mandatorySkills={previewRoleData?.mandatorySkillNames ?? null}
          optionalSkills={previewRoleData?.optionalSkillsName?.map(
            item => item?.name
          )}
          isRemoteAllowed={previewRoleData?.isRemoteAllowed}
          remoteCities={previewRoleData?.remoteCities}
          degrees={previewRoleData?.degreeStreamMap}
          specialisations={previewRoleData?.specialisations}
          yearOfPassing={previewRoleData?.yearOfPassing}
          isArrearsAllowed={previewRoleData?.isArrearsAllowed}
          arrearCount={previewRoleData?.arrearCount}
          isHistoryArrears={previewRoleData?.isHistoryArrears}
          historyArrearCount={previewRoleData?.historyArrearCount}
          avgScore={previewRoleData?.avgScore}
          arrearCondition={previewRoleData?.arrearCondition}
          tenthScore={previewRoleData?.tenthScore}
          twelthScore={previewRoleData?.twelfthScore}
          UGScore={previewRoleData?.UGScore}
          PGScore={previewRoleData?.PGScore}
          minCompensation={previewRoleData?.minCompensation}
          maxCompensation={previewRoleData?.maxCompensation}
          isHybridAllowed={previewRoleData?.isHybridAllowed}
          hybridType={previewRoleData?.hybridCondition?.type
            ?.slice(0, -2)
            ?.toLowerCase()}
          hybridDays={previewRoleData?.hybridCondition?.days}
          ctcPeriod={
            previewRoleData?.CTCPeriod == 'ANNUALLY'
              ? 'Per annum'
              : previewRoleData?.CTCPeriod == 'MONTHLY'
              ? 'Per month'
              : ''
          }
          publishTo={previewRoleData?.publishTo}
          candidatesCount={previewRoleData?.minVacancies && previewRoleData?.maxVacancies 
            ? `${previewRoleData?.minVacancies} - ${previewRoleData?.maxVacancies}` 
            : previewRoleData?.maxVacancies || previewRoleData?.minVacancies || 'Not specified'}
        />
      </RightSection>
    </FlexWrap>
  )
}

export default PreviewContent
